import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9734ecea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9734ecea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9734ecea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActivityCard: require('/workspace/components/ActivityCard.vue').default})
